import { useRef } from 'react';

const SWIPE_THRESHOLD_PX = 48;

type UseSwipeOptions = {
  onSwipeLeft: () => void;
  onSwipeRight: () => void;
};

export function useSwipe({ onSwipeLeft, onSwipeRight }: UseSwipeOptions) {
  const start = useRef<{ x: number; y: number } | null>(null);

  function onTouchStart(e: React.TouchEvent) {
    if (e.touches.length !== 1) {
      start.current = null;
      return;
    }

    const touch = e.touches[0];
    start.current = { x: touch.clientX, y: touch.clientY };
  }

  function onTouchEnd(e: React.TouchEvent) {
    if (!start.current) return;

    const touch = e.changedTouches[0];
    const deltaX = touch.clientX - start.current.x;
    const deltaY = touch.clientY - start.current.y;
    start.current = null;

    if (Math.abs(deltaX) < SWIPE_THRESHOLD_PX) return;
    if (Math.abs(deltaX) <= Math.abs(deltaY)) return;

    if (deltaX < 0) onSwipeLeft();
    else onSwipeRight();
  }

  function onTouchCancel() {
    start.current = null;
  }

  return { onTouchStart, onTouchEnd, onTouchCancel };
}
